import * as React from 'react'
import { configOptions } from './config'

export const ShaclFormWidgetDescription = {
  name: 'Shacl Form',
  component: React.lazy(() => import('./shacl-form-widget')),
  label: 'Shacl Form New [Unstable]',
  variables: configOptions,
}
